import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

import { FormButton } from '@/common/components/form-button';
import { FormInput } from '@/common/components/form-input';
import { FormListbox } from '@/common/components/form-listbox';
import { FormTextArea } from '@/common/components/form-textarea';

// Create form contexts
export const {
  fieldContext: appFieldContext,
  formContext: appFormContext,
  useFieldContext: useAppFieldContext,
  useFormContext: useAppFormContext
} = createFormHookContexts();

/**
 * Configured form hook that registers our custom form components.
 *
 * This creates a form system with pre-registered components that can be used
 * throughout the application for consistent form handling.
 *
 * @example
 * ```tsx
 * const form = useAppForm({
 *   defaultValues: { email: '' },
 *   validators: { onChange: emailSchema }
 * });
 *
 * return (
 *   <form onSubmit={form.handleSubmit}>
 *     <form.Field name="email" children={field => <field.FormInput label="Email" type="email" />} />
 *   </form>
 * );
 * ```
 */
export const { useAppForm, withForm: withAppForm } = createFormHook({
  fieldComponents: {
    FormInput,
    FormListbox,
    FormTextArea
  },
  formComponents: {
    FormButton
  },
  fieldContext: appFieldContext,
  formContext: appFormContext
});
